import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Typography } from '@dagensmat/carrot/Components';
import SectionHOC from '_common/components/section-hoc/SectionHOC';
import { B } from 'utils/fonts';
import { ButtonLink } from '_common/components/button/Button.style';

const MaxWidthContainer = styled.div`
  width: 100%;
  max-width: 490px;
`;

type ProfileMinimumOrderSectionProps = {
  minimumOrderAmount?: number;
};

const ProfileMinimumOrderSection = ({
  minimumOrderAmount = 0
}: ProfileMinimumOrderSectionProps) => {
  const { t } = useTranslation();
  return (
    <MaxWidthContainer>
      <Typography variant="paragraph" mb="s">
        {minimumOrderAmount ? (
          <Trans
            t={t}
            i18nKey="producer:MinimumOrderAmountLinkDescriptionWhenSet"
            values={{ minimumOrderAmount }}
            components={{ B: <B /> }}
          />
        ) : (
          t('producer:MinimumOrderAmountLinkDescriptionWhenNotSet')
        )}
      </Typography>

      <ButtonLink
        to={{
          pathname: '/profile/minimum-order'
        }}
        state={{ returnPath: true }}
        variant="ghost"
      >
        {minimumOrderAmount
          ? t('producer:MinimumOrderLinkText')
          : t('producer:MinimumOrderSetLinkText')}
      </ButtonLink>
    </MaxWidthContainer>
  );
};

export default SectionHOC(ProfileMinimumOrderSection);
